import { useState } from "react"
import { getGraph } from "../api/api"

export default function BacklinkGraph() {
  const [domain, setDomain] = useState("")
  const [graph, setGraph] = useState(null)

  async function load() {
    const res = await getGraph(domain)
    setGraph(res.data)
  }

  return (
    <div className="page">
      <h1>Backlink Graph</h1>
      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={load}>Load graph</button>
      </div>
      {graph && <pre>{JSON.stringify(graph, null, 2)}</pre>}
    </div>
  )
}
